"use client";
import { createContext, useContext } from "react"
import useSWR, { SWRResponse } from "swr"

import { API_ROUTES } from "@/constants/routes"
import useToggle from "@/hooks/use-toggle"
import { fetcher } from "@/lib/utils"
import { Tables } from "@/types/supabase"

type AppContextState = {
  isSidebarOpen: boolean;
  toggleSidebarOpen: () => void;
  subscription: SWRResponse<Tables<"subscription">>;
};

const AppContext = createContext<AppContextState | undefined>(undefined);

export function AppContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isOpen, toggle] = useToggle(true);
  const subscription = useSWR<Tables<"subscription">>(
    API_ROUTES.SUBSCRIPTION,
    fetcher
  );

  return (
    <AppContext.Provider
      value={{
        isSidebarOpen: isOpen,
        toggleSidebarOpen: toggle,
        subscription,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  const context = useContext(AppContext);

  if (!context) {
    throw new Error("useAppContext must be within AppContextProvider");
  }

  return context;
}
